import { render, staticRenderFns } from "./CardCalendar.vue?vue&type=template&id=2e037ed6&scoped=true"
import script from "./CardCalendar.vue?vue&type=script&lang=js"
export * from "./CardCalendar.vue?vue&type=script&lang=js"
import style0 from "./CardCalendar.vue?vue&type=style&index=0&id=2e037ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e037ed6",
  null
  
)

export default component.exports